import React from "react";
import DepartmentList from "../../components/Organizations/DepartmentList/DepartmentList";

const OrganizationDesignation = () => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between px-10 pb-4 mt-8">
        <div>
          <h2>Designation</h2>
        </div>
        <div>
          <a href="" className="btn text-[14px]">
            <span>
              <i className="ico-plus text-white mr-3"></i>
            </span>
            Add Designation
          </a>
        </div>
      </div>
      <DepartmentList />
    </div>
  );
};

export default OrganizationDesignation;
